import { RepresentativeType } from '../enums/representative-type.enum';
import { RepresentativePoliticallyExposed } from './representative-politically-exposed';

export class RepresentativesData {
  constructor() {
    this.politicallyExposed = new RepresentativePoliticallyExposed();
  }

  id?: string;

  currentStep: string;

  socialNumber?: string;

  name?: string;

  qualification?: string;

  nationalDocument?: string;

  role: string;

  isPoliticallyExposed?: boolean;

  signatureType?: string;

  politicallyExposed?: RepresentativePoliticallyExposed;

  email?: string;

  portalAccess: boolean;

  masterAccess: boolean = false;

  isMeetingRepresentant: boolean;

  phone?: string;

  representativeType?: RepresentativeType;

  percentageShareholding?: number;
}
